<template>
    <tr>
        <td class="id">
            <div class="id font-normal">{{ id }}</div>
        </td>
        <td>
            <div class="top font-normal">{{ name | maxLength }}</div>
            <div class="bottom font-small">{{ code }}</div>
        </td>
        <td class="right">
            <div class="top font-normal">{{ length }}</div>
        </td>
    </tr>
</template>

<script>
  export default {
    props: ['id', 'name', 'code', 'length']
  }
</script>



